import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-single",
  "use": "chevron-single-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-single\"><path fill-rule=\"evenodd\" d=\"m16.589 8-4.588 4.579L7.412 8H7.41L6 9.409l6.001 6.001L18 9.409 16.591 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol